<div class='template'>
  <div [class.loader-hidden]="!showSpinner">
    <div class ="loader-overlay" *ngIf="showSpinner">
      <div *ngIf="showSignupWarningmessage" class="signup-loader-text">{{'common.signUpWarningMessage' |translate | translateKey}}</div>
      <div><i id ="loader" class="fa fa-spinner fa-pulse fa-5x fa-fw"></i></div>
    </div>
  </div>
</div>
